import { createColumnHelper } from "@tanstack/react-table";

import CrudActions from "components/crud/CrudActions";

const columnHelper =
    createColumnHelper();


export const roleColumns = ({
    onEdit,
    onDelete,
}) => [

    // =========================================================
    // NAME
    // =========================================================

    columnHelper.accessor(
        "name",
        {
            id: "name",

            header: () => (
                <span className="text-xs font-bold uppercase text-gray-500">
                    Name
                </span>
            ),

            cell: (info) => (
                <p className="font-semibold text-white-700 dark:text-white">
                    {info.getValue() || "-"}
                </p>
            ),
        }
    ),


    // =========================================================
    // SLUG
    // =========================================================

    columnHelper.accessor(
        "slug",
        {
            id: "slug",

            header: () => (
                <span className="text-xs font-bold uppercase text-gray-500">
                    Slug
                </span>
            ),

            cell: (info) => (
                <span
                    className="
                        inline-flex
                        rounded-md
                        border
                        border-gray-200
                        bg-gray-50
                        px-2.5
                        py-1
                        text-xs
                        font-medium
                        text-gray-700
                    "
                >
                    {info.getValue() || "-"}
                </span>
            ),
        }
    ),


    // =========================================================
    // USERS
    // =========================================================

    columnHelper.accessor(
        "usersCount",
        {
            id: "usersCount",

            header: () => (
                <span className="text-xs font-bold uppercase text-gray-500">
                    Users
                </span>
            ),

            cell: (info) => (
                <div className="text-center font-medium">
                    {info.getValue() || 0}
                </div>
            ),
        }
    ),


    // =========================================================
    // PERMISSIONS
    // =========================================================

    columnHelper.accessor(
        "permissions",
        {
            id: "permissions",

            header: () => (
                <span className="text-xs font-bold uppercase text-gray-500">
                    Permissions
                </span>
            ),

            cell: (info) => {

                const permissions =
                    info.getValue();

                const count =
                    Array.isArray(permissions)
                        ? permissions.length
                        : Number(
                            permissions || 0
                        );

                return (
                    <div className="text-center font-medium">
                        {count}
                    </div>
                );
            },
        }
    ),


    // =========================================================
    // STATUS
    // =========================================================

    columnHelper.accessor(
        "status",
        {
            id: "status",

            header: () => (
                <span className="text-xs font-bold uppercase text-gray-500">
                    Status
                </span>
            ),

            cell: (info) => {

                const status =
                    info.getValue() ||
                    "active";

                const statusClass =
                    status === "active"
                        ? `
                            border-green-200
                            bg-green-50
                            text-green-700
                          `
                        : `
                            border-red-200
                            bg-red-50
                            text-red-700
                          `;

                return (
                    <span
                        className={`
                            inline-flex
                            rounded-full
                            border
                            px-3
                            py-1
                            text-xs
                            font-semibold
                            capitalize
                            ${statusClass}
                        `}
                    >
                        {status}
                    </span>
                );
            },
        }
    ),


    // =========================================================
    // ACTIONS
    // =========================================================

    columnHelper.display({

        id: "actions",

        header: () => (
            <span className="text-xs font-bold uppercase text-gray-500">
                Actions
            </span>
        ),

        cell: ({ row }) => {

            const role =
                row.original;

            return (
                <CrudActions

                    showEdit={
                        typeof onEdit ===
                        "function"
                    }

                    onEdit={
                        onEdit
                            ? () =>
                                onEdit(
                                    role
                                )
                            : undefined
                    }

                    editTitle="Edit Role"


                    showDelete={
                        typeof onDelete ===
                        "function" &&
                        role.status !==
                            "inactive"
                    }

                    onDelete={
                        onDelete &&
                        role.status !==
                            "inactive"
                            ? () =>
                                onDelete(
                                    role.id
                                )
                            : undefined
                    }

                    deleteTitle="Deactivate Role"

                />
            );
        },
    }),

];